export default __webpack_public_path__ + "static/media/UserDefaultAvatar.925326ca.svg";